import { createStore as reduxCreateStore, applyMiddleware, compose } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import { logger } from 'redux-logger';
import { window } from 'global';
import ga from 'react-ga';
import createSagaMiddleware from 'redux-saga';

import { getFlag } from 'config/flags';
import devDebug from 'config/debug';
import googleAnalytics from 'middleware/googleAnalytics';
import unhandledErrorMiddleware from 'middleware/unhandledError';
import windowMiddleware from 'middleware/window';
import rootSaga from 'middleware/sagas';
import rootReducer from 'reducers';

export default function createStore() {
  const isProd = getFlag('env') === 'prod';
  const swEnabled = getFlag('swEnabled') === true;

  const sagaMiddleware = createSagaMiddleware();

  const middleware = [
    unhandledErrorMiddleware(window),
    routerMiddleware(browserHistory),
    sagaMiddleware,
    googleAnalytics(ga),
    windowMiddleware(window),
  ];

  if (!isProd) {
    middleware.push(logger);
  }

  const enhancers = [
    applyMiddleware(...middleware),
  ];

  if (swEnabled) {
    enhancers.push(autoRehydrate({ log: true }));
  }

  const store = reduxCreateStore(rootReducer, undefined, compose(...enhancers));

  if (swEnabled) {
    persistStore(store, { whitelist: [ 'auth', 'user' ] });
  }

  // must be run after middleware has been applied
  sagaMiddleware.run(rootSaga);

  // attach ag to the window
  window.ag = devDebug(store, window);

  return store;
}



// WEBPACK FOOTER //
// ./src/store/createStore.js